export default __webpack_public_path__ + "static/media/gg.b08bf450.svg";